module.exports = __webpack_public_path__ + "media/promo/promo/images/round-more-b2f21db69c9a5507268a72e898efac15.svg";